var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAllSearchOption = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_search",
    "data-name": "Icon - search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M19.862,18.812l-5.039-5.039a.464.464,0,0,0-.332-.137h-.4a8.043,8.043,0,1,0-.453.457v.4a.48.48,0,0,0,.137.332l5.039,5.039a.469.469,0,0,0,.664,0l.387-.387A.469.469,0,0,0,19.862,18.812ZM8.125,15A6.875,6.875,0,1,1,15,8.125,6.87,6.87,0,0,1,8.125,15Z",
    fill: "#0d47a1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "search-2",
    "data-name": "search",
    d: "M19.862,18.812l-5.039-5.039a.464.464,0,0,0-.332-.137h-.4a8.043,8.043,0,1,0-.453.457v.4a.48.48,0,0,0,.137.332l5.039,5.039a.469.469,0,0,0,.664,0l.387-.387A.469.469,0,0,0,19.862,18.812ZM8.125,15A6.875,6.875,0,1,1,15,8.125,6.87,6.87,0,0,1,8.125,15Z",
    fill: "#0d47a1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAllSearchOption);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/all-search-option.acb7795ee8784e3896b0c91a2d2cb990.svg";